import React from 'react';
import { JBTypography } from '@jbhi-fi/lanyard-ui';

const LoadingComponent = ({ message }) => {
  return (
    <div className="loading-mask">
      <div className="ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <JBTypography type="h6" margin="0" align="center">
        {message ? message : 'Loading...'}
      </JBTypography>
    </div>
  );
};

export default LoadingComponent;
